// Alert level color mapping
const alertUnknownColor = 'var(--color-pxCaseLvlUnknown)';
const alertBtwnUsrsColor = 'var(--color-pxCaseBtwnUsrs)';
const alert3Color = 'var(--color-pxCaseLvl3)';
const alert2Color = 'var(--color-pxCaseLvl2)';
const alert1Color = 'var(--color-pxCaseLvl1)';
const alert0Color = 'var(--color-pxCaseLvl0)';

const csLvlColor = (
  csLvl,
  // csClose = false,
  // csHold = false,
  csBtwnUsrs = false,
  csUsrsCflct = false,
) => {
  // if (csClose) return alertCloseColor;

  // if (csHold) return alertUnknownColor;

  if (csBtwnUsrs && (!csUsrsCflct)) return alertBtwnUsrsColor;

  switch (csLvl) {
    case 0: return alert0Color;
    case 1: return alert1Color;
    case 2: return alert2Color;
    case 3: return alert3Color;
    default: return alertUnknownColor;
  }
};

export default csLvlColor;
